export const API_URL = "https://frw7otlawr6rc6oxocljzqry7e0zhpvd.lambda-url.us-west-2.on.aws/";
// export const API_URL = "http://localhost:3001/";